import type { ReactNode } from 'react';

export const symbol_table_view: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M300-80q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h520q24 0 42 18t18 42v520q0 24-18 42t-42 18H300Zm0-60h230v-147H300v147Zm290 0h230v-147H590v147ZM109.82-244Q97-244 88.5-252.63 80-261.25 80-274v-546q0-24 18-42t42-18h546q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140v546q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63ZM300-347h230v-148H300v148Zm290 0h230v-148H590v148ZM300-555h520v-105H300v105Z"
		/>
	</svg>
);
